import React from 'react';
import { CLEAR_ERRORS } from '#action/types';
import { whitelabel } from '#config/whitelabel';
import { CompanyImgCnt, CompanyImgLogo, H5, Link, Main, Paper, Subtitle1 } from './styles';

/**
 * Handles child components sync errors.
 * Handles dispatched async errors.
 */

class ErrorBoundary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };

    this.clearErrors = this.clearErrors.bind(this);
  }

  componentDidMount() {
    window.addEventListener('popstate', this.clearErrors);
  }

  static getDerivedStateFromError() {
    return { hasError: true, error: 'Something went wrong' };
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.clearErrors);
  }

  clearErrors() {
    const { dispatch, errors } = this.props;
    const { hasError } = this.state;
    if (errors.length) {
      dispatch({
        type: CLEAR_ERRORS
      });
    }
    if (hasError) {
      this.setState({ hasError: false, error: null });
    }
  }

  render() {
    const { errors, mainPage, account } = this.props;
    const { hasError, error } = this.state;
    const projects = account.directProjects || [];

    const mainPagePath = projects.length ? mainPage || '/device' : `/user/${account.id}`;

    if (hasError || errors.length) {
      return (
        <Main className="error-boundary">
          <Paper>
            <CompanyImgCnt>
              <CompanyImgLogo
                src={whitelabel.buildAssetUrl('media/logo.svg')}
                alt="logo"
              />
            </CompanyImgCnt>
            <H5 component="h1" variant="h5">
              {error || errors[0].errorMessage || errors[0].message}
            </H5>
            <Subtitle1 component="h1" variant="subtitle1">
              {'Go to the '}
              <Link href={mainPagePath}>
                main page
              </Link>
            </Subtitle1>
          </Paper>
        </Main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
